<!--
  The top bar spans the full width, above the side menu, so the nav rail sits under
  the bar. Its hamburger collapses the rail to icons rather than closing it.
-->
<styles-card-top-bar
  class="shell-top-bar"
  [menuToggle]="true"
  [profilePic]="avatarUrl() ?? ''"
  (menuToggled)="toggleRail()"
>
  <!--
    `[menu-options]` IS the user chip's dropdown: the library renders the chip and the
    menu panel, and projects whatever is slotted here into it. So these are bare
    `mat-menu-item`s with no trigger or `mat-menu` of our own — same as atlas-app-v2.
  -->
  <span menu-options>
    <div class="account-menu-name">{{ displayName() }}</div>
    <mat-divider></mat-divider>
    <button mat-menu-item type="button" (click)="logOut()">
      <mat-icon>power_settings_new</mat-icon>
      <span>Log Out</span>
    </button>
  </span>
</styles-card-top-bar>

<app-side-menu class="shell-side-menu" [class.icon-menu]="railCollapsed()">
  <div page-content class="shell-content">
    <!--
      The library's top bar has no breadcrumb slot (its slots are notifications,
      profile picture and menu options), so the trail sits at the top of the content
      column rather than being dropped. styles-bread-crumb /
      styles-sidenav-content-spacer are the library-native home for this if we move
      breadcrumbs into the pages themselves.
    -->
    @if (breadcrumbs().length) {
      <nav class="shell-breadcrumb" aria-label="Breadcrumb">
        @for (crumb of breadcrumbs(); track $index; let first = $first; let last = $last) {
          @if (!first) {
            <mat-icon class="crumb-sep">chevron_right</mat-icon>
          }
          <span [class.crumb-muted]="!last" [class.crumb-current]="last">{{ crumb }}</span>
        }
      </nav>
    }

    <main class="shell-main">
      <router-outlet />
    </main>
  </div>
</app-side-menu>
